import React, { useState } from "react";

const ContextLanding = () => {
  const [email, setEmail] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Original implementation (commented out)
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   
  //   if (email && email.includes('@')) {
  //     setIsSubmitting(true);
  //     
  //     try {
  //       // Submit to your backend endpoint
  //       const response = await fetch('/api/subscribe', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({ email }),
  //       });
  //
  //       if (response.ok) {
  //         setShowSuccess(true);
  //         setEmail('');
  //         
  //         setTimeout(() => {
  //           setShowSuccess(false);
  //         }, 4000);
  //       } else {
  //         throw new Error('Failed to subscribe');
  //       }
  //     } catch (error) {
  //       console.error('Subscription error:', error);
  //       // Still show success to user for better UX, but log the error
  //       setShowSuccess(true);
  //       setEmail('');
  //       
  //       setTimeout(() => {
  //         setShowSuccess(false);
  //       }, 4000);
  //     } finally {
  //       setIsSubmitting(false);
  //     }
  //   }
  // };

  // Temporary Signal notification implementation
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (email && email.includes('@')) {
      setIsSubmitting(true);
      
      console.log('Waitlist submission:', { email });
      
      // Prepare the message text
      const messageText = `New Tinycloud waitlist submission. Email: ${email}`;
      const encodedText = encodeURIComponent(messageText);
      
      // Send Signal notification
      try {
        const response = await fetch(`https://signal.callmebot.com/signal/send.php?phone=86519f71-8836-4af2-8dc6-f48fc1ea352b&apikey=891497&text=${encodedText}`);
        const result = await response.text();
        console.log('Signal notification result:', result);
      } catch (error) {
        console.error('Error sending Signal notification:', error);
      }
      
      setShowSuccess(true);
      setEmail('');
      
      setTimeout(() => {
        setShowSuccess(false);
      }, 4000);
      
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#4473b9] via-[#4473b9] to-[#4473b9] text-white font-inter antialiased relative overflow-hidden">
      {/* Grain effect */}
      <div 
        className="fixed inset-0 opacity-[0.03] z-[1] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
        }}
      />
      
      {/* Gradient background */}
      <div className="fixed inset-0 z-[1] pointer-events-none">
        <div 
          className="absolute inset-0"
          style={{
            background: `radial-gradient(ellipse at top center, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
                        radial-gradient(ellipse at bottom right, rgba(244, 247, 231, 0.08) 0%, transparent 50%)`
          }}
        />
      </div>
      
      {/* Main content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-8 py-4">
        <div className="max-w-[720px] w-full text-center">
          {/* Logo */}
          <div className="flex justify-center opacity-0 transform translate-y-5 animate-[fadeInUp_0.8s_ease-out_0.2s_forwards]">
            <img
              src="/tinycloud-logo.png"
              alt="TinyCloud"
              className="h-36 md:h-48 w-auto object-contain"
            />
          </div>
          
          {/* Main headline */}
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-[-0.04em] leading-[1.2] md:leading-[0.95] mb-8 bg-gradient-to-b from-white to-gray-300 bg-clip-text text-transparent opacity-0 transform translate-y-8 animate-[fadeInUp_1s_ease-out_0.4s_forwards]">
            Imagine AI That<br />Actually Knows You
          </h2>
          
          {/* Subtitle content */}
          <div className="opacity-0 transform translate-y-5 animate-[fadeInUp_0.8s_ease-out_0.8s_forwards] mb-12">
            <p className="text-2xl text-white/90 mb-6 max-w-4xl mx-auto font-light leading-relaxed">
              AI that already knows your sleep patterns, work progress, relationships, diet, and everything else that matters to you.
            </p>
            
            <p className="text-2xl text-white/90 max-w-4xl mx-auto font-light leading-relaxed">
              No more explaining yourself—just efficient, meaningful dialogue with AI that understands your whole story.
            </p>
          </div>

          {/* Feature highlights */}
          <div className="flex flex-col lg:flex-row lg:justify-between gap-8 lg:gap-12 mb-12 items-center">
            {/* Connect Everything */}
            <div className="flex-1 text-center">
              <div className="text-4xl mb-4">🔌</div>
              <div className="md:whitespace-nowrap text-4xl md:text-2xl font-extrabold tracking-[-0.04em] leading-1 mb-2 bg-gradient-to-b from-white to-gray-300 bg-clip-text text-transparent">Connect Everything</div>
              <div className="text-2xl md:text-xl text-white/90 font-light leading-[1.4]">Link any app <br />or data source</div>
            </div>
            
            {/* Private & Secure */}
            <div className="flex-1 text-center">
              <div className="text-4xl mb-4">🔒</div>
              <div className="md:whitespace-nowrap text-4xl md:text-2xl font-extrabold tracking-[-0.04em] leading-1 mb-2 bg-gradient-to-b from-white to-gray-300 bg-clip-text text-transparent">Private & Secure</div>
              <div className="text-2xl md:text-xl text-white/90 font-light leading-[1.4]">Secured with <br />Sign In With Ethereum</div>
            </div>
            
            {/* Full Context */}
            <div className="flex-1 text-center">
              <div className="text-4xl mb-4">🧠</div>
              <div className="md:whitespace-nowrap text-4xl md:text-2xl font-extrabold tracking-[-0.04em] leading-1 mb-2 bg-gradient-to-b from-white to-gray-300 bg-clip-text text-transparent">Full Context</div>
              <div className="text-2xl md:text-xl text-white/90 font-light leading-[1.4]">Always up-to-date <br />context</div>
            </div>
          </div>
          
          {/* Form container */}
          <div className="bg-white/[0.03] backdrop-blur-[20px] border border-white/[0.08] rounded-3xl p-8 md:p-12 mb-8 opacity-0 transform translate-y-5 animate-[fadeInUp_0.8s_ease-out_1.2s_forwards]">
            <h3 className="whitespace-nowrap text-4xl md:text-2xl font-extrabold tracking-[-0.04em] leading-1 bg-gradient-to-b from-white to-gray-300 bg-clip-text text-transparent opacity-0 transform translate-y-8 animate-[fadeInUp_1s_ease-out_0.4s_forwards] mb-2 md:mb-1">
              Join the Waiting List
            </h3>
            <p className="text-2xl md:text-xl text-white/90 font-light leading-[1.4] mb-6">Be first to experience instantly contextualized AI</p>
            
            <form onSubmit={handleSubmit} className="flex gap-4 mb-6 flex-col md:flex-row">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-8 py-5 border-2 border-white/20 rounded-[32px] bg-white/10 text-white text-xl font-normal outline-none transition-all duration-300 placeholder:text-white/50 focus:border-white/40 focus:bg-white/15 hover:border-white/30 hover:bg-white/12 shadow-lg backdrop-blur-sm"
                placeholder="Enter your email"
                required
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className={`px-12 py-5 rounded-[32px] font-bold text-xl transition-all duration-300 shadow-lg whitespace-nowrap ${
                  isSubmitting 
                    ? 'bg-white/50 text-[#4473b9]/50 cursor-not-allowed' 
                    : 'bg-white text-[#4473b9] hover:bg-[#F4F7E7] hover:shadow-2xl transform hover:-translate-y-2'
                }`}
              >
                {isSubmitting ? 'Joining...' : 'Join Waiting List'}
              </button>
            </form>
            
            <div className="bg-white/5 border border-white/10 rounded-2xl p-4 text-white/70 backdrop-blur-sm">
              <div className="text-lg font-semibold text-white/90">Invitation-only beta program</div>
              <div className="text-base">Built by former OpenAI & SpruceID engineers</div>
            </div>
            
            {showSuccess && (
              <div className="bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 rounded-xl p-4 mt-4 font-medium">
                ✅ You're on the list! Buckle up!
              </div>
            )}
          </div>
          
          <p className="text-white/40 mb-2 text-sm font-normal opacity-0 transform translate-y-5 animate-[fadeInUp_0.8s_ease-out_1.6s_forwards]">
            © 2025 TinyCloud | Your context, your keys, your choice
          </p>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        ::selection {
          background: rgba(59, 130, 246, 0.3);
          color: white;
        }
        
        ::-moz-selection {
          background: rgba(59, 130, 246, 0.3);
          color: white;
        }
        
        html {
          scroll-behavior: smooth;
        }
      `}</style>
    </div>
  );
};

export default ContextLanding;